import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { PointReminderModalService } from '../point-reminder-modal/point-reminder-modal.service';

@Component({
    selector: 'pp-point-reminders-header',
    templateUrl: './point-reminders-header.component.html',
    styleUrls: ['./point-reminders-header.component.scss'],
    standalone: false
})
export class PointRemindersHeaderComponent {
  @Input() ppPointId: string = '';
  @Input() ppHide: boolean = false;
  EIconPath = EIconPath;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private pointReminderModalService: PointReminderModalService,
  ) {}

  back(): void {
    this.router.navigate(['..'], { relativeTo: this.activatedRoute });
  }

  newReminder(): void {
    this.pointReminderModalService.showReminderModal({ pointId: this.ppPointId });
  }
}
